import { render, staticRenderFns } from "./order-push.vue?vue&type=template&id=a9c872be&scoped=true"
import script from "./order-push.vue?vue&type=script&lang=js"
export * from "./order-push.vue?vue&type=script&lang=js"
import style0 from "./order-push.vue?vue&type=style&index=0&id=a9c872be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c872be",
  null
  
)

export default component.exports